import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import * as teamActions from "..//team.actions";
import { getCurrentUserTeam, getUsersForCurrentUserTeam } from "../team.selectors";

import { getCurrentUser } from "../../user/user.selectors";
import { formatDate } from "../../../utils/date-utils";

import Table from "../../common/components/Table";
import { ContentBlock } from "../../pages/components";
import Button from "../../../ui/button/Button";
import { Localize } from "../../../locale/localization";
import TableHeader from "../../common/components/TableHeader";
import { sortTableAndHead } from "../../../utils/content-utils";

class TeamSummaryBlock extends Component {
  state = {
    sortedData: [],
    tableHead: [
      { name: "name", uiName: Localize("user") },
      { name: "createdAt", uiName: Localize("joined") },
      { name: "role", uiName: Localize("rights") }
    ]
  };

  componentWillMount() {
    this.updateSortData(this.props.teamUsers);
  }

  componentWillReceiveProps(nextProps) {
    this.updateSortData(nextProps.teamUsers);
  }

  updateSortData = content => {
    this.setState(
      Object.assign({}, this.state, {
        sortedData: content ? content : []
      })
    );
  };

  sortTable = headItem => {
    const sorted = sortTableAndHead(headItem, this.state.tableHead, this.state.sortedData);

    this.setState(
      Object.assign({}, this.state, {
        sortedData: sorted.data,
        tableHead: sorted.head
      })
    );
  };

  componentWillMount = () => {
    const { getTeam, currentUser } = this.props;

    getTeam(currentUser.team._id);
  };

  renderHeaderActions() {
    return (
      <NavLink to="/admin/users/add">
        <Button icon="#plus">{Localize("action.invite.user")}</Button>
      </NavLink>
    );
  }

  renderUserRow = user => {
    const { _id, firstName, lastName, email, createdAt, role } = user;

    const displayName = firstName && lastName ? `${firstName} ${lastName}` : email;

    return (
      <tr key={_id}>
        <td>{displayName}</td>
        <td>{formatDate(createdAt)}</td>
        <td>{Localize(`user.role.${role}`)}</td>
      </tr>
    );
  };

  renderTableHeader = () => {
    return (
      <TableHeader
        items={this.state.tableHead}
        onSort={this.sortTable}
        sortable={this.state.sortedData.length > 1}
      />
    );
  };

  render() {
    const { currentUserTeam } = this.props;
    const teamUsers = this.state.sortedData;

    return (
      <ContentBlock title={currentUserTeam.name} renderActions={this.renderHeaderActions}>
        <Table
          items={teamUsers}
          renderHeader={this.renderTableHeader}
          renderItem={this.renderUserRow}
        />
      </ContentBlock>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const currentUserTeam = getCurrentUserTeam(state);
  const teamUsers = getUsersForCurrentUserTeam(state);

  return {
    currentUser,
    currentUserTeam,
    teamUsers
  };
};

const ConnectedTeamSummaryBlock = connect(mapStateToProps, Object.assign({}, teamActions))(
  TeamSummaryBlock
);

export default ConnectedTeamSummaryBlock;



// WEBPACK FOOTER //
// ./src/modules/team/components/TeamSummaryBlock.js